var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicroscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_425",
    "data-name": "Group 425",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.522,
    height: 35.114,
    viewBox: "0 0 23.522 35.114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M8.36,33.417A3.551,3.551,0,0,0,5,37.114H28.522a3.551,3.551,0,0,0-3.36-3.7H18.441v-3.7h5.04a3.551,3.551,0,0,0,3.36-3.7H13.4a5.3,5.3,0,0,1-5.04-5.544,5.669,5.669,0,0,1,2.47-4.75A4.065,4.065,0,0,0,13.9,17.69a3.947,3.947,0,0,0,3.108-1.146L18,19.52l1.579-.628.571,1.737,3.159-1.257-.571-1.737,1.579-.628-4.6-13.9-1.579.628L17.568,2,14.409,3.257l.571,1.737L13.4,5.641l.941,2.865a4.251,4.251,0,0,0-4.167,3.437A9.311,9.311,0,0,0,5,20.481c0,5.1,3.764,9.24,8.4,9.24v3.7Zm9.846-26.76,2.873,8.686-1.579.628L16.627,7.286ZM14.241,11.24a1.775,1.775,0,0,1,1.68,1.848,1.775,1.775,0,0,1-1.68,1.848,1.775,1.775,0,0,1-1.68-1.848A1.775,1.775,0,0,1,14.241,11.24Z",
    transform: "translate(-5 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroscope);
export default __webpack_public_path__ + "static/media/microscope.46768c65f65bf0884aa22b0d140dcd00.svg";
export { ForwardRef as ReactComponent };